import React, { ReactElement } from 'react';
import { Mutation } from '@apollo/client/react/components';
import UpdatePaymentMethodBtn from '@buyside/components/presentation/UserAccount/BillingInformation/PaymentMethod/updatePaymentMethodBtn';

import {
  MakeCheckoutSessionUpdatePaymentMethodDocument,
  MakeCheckoutSessionUpdatePaymentMethodMutation,
  MakeCheckoutSessionUpdatePaymentMethodMutationVariables
} from '@interfaces/graphql-typings';

const PaymentMethodContainer = (): ReactElement => (
  <Mutation<
    MakeCheckoutSessionUpdatePaymentMethodMutation,
    MakeCheckoutSessionUpdatePaymentMethodMutationVariables
  >
    mutation={MakeCheckoutSessionUpdatePaymentMethodDocument}
  >
    {(mutate): ReactElement => <UpdatePaymentMethodBtn makeCheckoutSessionUpdatePayment={mutate} />}
  </Mutation>
);

export default PaymentMethodContainer;
